export enum VgbmAssignmentQuality {
  UNKNOWN = 10,
  NON_COMPLIANT = 20,
  SUPPLIER_PROVIDED_NOT_CHECKED = 40,
  SUPPLIER_PROVIDED = 60,
  MANUAL_ENTRY = 80,
}
